<div class="parcel-list-panel card panel-flat-color secondary-panel h-100">
    <div class="panel-flat-header">
        <h3>Parcel List</h3>
        <ws-switch (selectedOptionChanged)="onViewChanged($event)"
                   [formControl]="contentTypeToggle"
                   class="parcel-list-switch"
                   helpContentId="parcel-list-panel.view-switch"
                   helpTooltip
                   offLabel="Tile"
                   onLabel="Table">
        </ws-switch>
        <div class="header-button-container" style="display: inline-block; margin-left: 20px; vertical-align: top;">
            @if (hasSiteWritePermission) {
                <button class="ace-btn btn-text has-icon fa fa-plus-circle" [disabled]="dataLoading || editMode"
                        (click)="showAddParcel()" title="Add Parcel"></button>
            }
        </div>
        <div class="float-end header-button-container header-right ws-flex-container-horizontal ws-flex-align-items-center">
            @if (isExcludeInactiveParcelsCheckboxVisible) {
                <label class="checkbox">
                    <input type="checkbox" name="excludeInactiveParcels" [formControl]="excludeInactiveParcels"> Exclude
                    Inactive
                </label>
            }
            <label class="tax-year-label">Assessed Tax Year: </label>
            <ws-select (selectedOptionChanged)="onTaxYearChanged($event)"
                       [formControl]="selectedTaxYear"
                       [isPrimitive]="true"
                       [options]="availableTaxYears"
                       [returnEntireOption]="true"
                       class="tax-year-select"
                       size="sm"></ws-select>

            @if (!editMode && contentTypeToggle.value && !dataLoading && canEdit) {
                <button type="button" class="ace-btn btn-text has-icon btn-primary m-0" (click)="edit()">
                    <i class="fa fa-pencil"></i></button>
            }
            @if (editMode) {
                <span>
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary btn-success m-0"
                            [disabled]="dataLoading || !hasChanges"
                            (click)="save()">
                        <i class="fa fa-save"></i>
                    </button>
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary btn-danger m-0"
                            [disabled]="dataLoading"
                            (click)="cancel()">
                        <i class="fa fa-close"></i>
                    </button>
                </span>
            }

            @if (!isExpanded) {
                <button type="button" class="ace-btn btn-text has-icon btn-secondary m-0" (click)="expandPanel()">
                    <i class="fa fa-arrows-alt" title="Expand"></i>
                </button>
            }
            @if (isExpanded) {
                <button type="button" class="ace-btn btn-text has-icon btn-secondary m-0" (click)="collapsePanel()">
                    <i class="fa fa-compress" title="Collapse"></i>
                </button>
            }
        </div>
        <div class="clearfix"></div>
    </div>
    <div [ngStyle]="{ height: (!isExpanded) ? '455px' : '100%' }" class="panel-flat-body ws-flex-container-vertical">

        @if (dataLoading) {
            <div class="ws-flex-align-self-center" style="margin-top: 160px">
                <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
            </div>
        }

        @if (!contentTypeToggle.value && parcelList && !dataLoading) {
            <div class="d-flex flex-wrap">
                @for (parcel of parcelList.tiles; track parcel) {
                    <parcel-tile [item]="parcel"
                                    (navigateToParcel)="navigateToParcel($event)"
                                    [stateAllowConsolidating]="stateAllowConsolidating"
                                    [ppReturnPreparationAllowed]="ppReturnPreparationAllowed">
                    </parcel-tile>
                }
            </div>
        }

        @if (contentTypeToggle.value || agGridReady) {
            <div
                [hidden]="!contentTypeToggle.value || dataLoading"
                class="ws-stretch-height">
                <ws-ag-grid-angular [gridOptions]="gridOptions"
                                    [companyId]="site.companyID"
                                    [gridId]="gridId"
                                    [isBulkUpdateVisible$]="isBulkUpdateVisible$"
                                    (gridReady)="onAgGridReady($event)"
                                    (bulkUpdate)="bulkUpdate()">
                </ws-ag-grid-angular>
            </div>
        }
    </div>
</div>
